(() => {
  'use strict';
  const configNode = document.getElementById('sr-popup-config');
  if (!configNode || window.__seriniaPopupLoaded) return;
  window.__seriniaPopupLoaded = true;
  const config = JSON.parse(configNode.textContent);
  if (!config.enabled) return;
  if (config.preview && config.themeRole === 'main') return;
  const dialog = document.getElementById('sr-newsletter-dialog');
  const root = dialog.querySelector('#serinia-reveal');
  const q = selector => root.querySelector(selector);
  const teaser = document.getElementById('sr-newsletter-teaser');
  const key = config.preview ? 'serinia.popup.qa.v1' : 'serinia.popup.v1';
  const params = new URLSearchParams(location.search);
  const emailVisit = params.has('_kx') || /^(email|klaviyo)$/i.test(params.get('utm_medium') || '') || /klaviyo/i.test(params.get('utm_source') || '');
  // Force-open is allowed in the unpublished review configuration only.
  const force = config.preview && params.get('sr_popup') === 'review';
  let memory = {}, step = 'pick', card = 0, busy = false, revealTimer;
  let previousFocus, scrollY = 0, height = 0, width = 0, elapsed = 0;
  let lastTick = performance.now(), lastActivityWrite = 0;
  let savedBody = null;
  const read = () => {
    try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch (_) { return memory; }
  };
  const write = patch => {
    memory = { ...read(), ...patch };
    try { localStorage.setItem(key, JSON.stringify(memory)); } catch (_) { /* session-only fallback */ }
  };
  if (Date.now() - (read().lastActivity || 0) >= 30 * 60000) write({ shownAt: 0 });
  function excluded() {
    return window.SeriniaPopupRules.reason({ now: Date.now(), record: read(), customer: config.customer,
      pathname: location.pathname, template: config.template, emailVisit, designMode: config.designMode });
  }
  function visible(el) {
    if (!el || el.closest('[hidden]')) return false;
    const r = el.getBoundingClientRect(), s = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && s.display !== 'none' && s.visibility !== 'hidden';
  }
  function competingUI() {
    const selectors = 'dialog[open], [role="dialog"][aria-modal="true"], #shopify-pc__banner, #onetrust-banner-sdk, #CybotCookiebotDialog, .needsclick.klaviyo-form, cart-drawer[open]';
    return Array.from(document.querySelectorAll(selectors)).some(el => el !== dialog && !dialog.contains(el) && visible(el));
  }
  function viewport() {
    const nextHeight = window.visualViewport?.height || innerHeight;
    const nextWidth = innerWidth;
    const editing = document.activeElement === q('#sr-email');
    if (nextWidth <= 700 && dialog.open && Math.abs(nextWidth - width) < 2 && (editing || nextHeight < height - 100)) return;
    height = nextHeight; width = nextWidth;
    dialog.style.setProperty('--preview-height', height + 'px');
  }
  function render() {
    ['pick', 'capture', 'done'].forEach(name => { q('.sr-' + name).hidden = step !== name; });
    root.classList.toggle('sr-form-state', step === 'capture');
    root.classList.toggle('sr-done-state', step === 'done');
    root.querySelectorAll('[data-card]').forEach(button => {
      button.classList.toggle('chosen', Number(button.dataset.card) === card);
      button.disabled = card !== 0;
    });
  }
  function open(manual = false) {
    if (dialog.open || busy || competingUI()) return;
    const reason = excluded();
    if (!force && reason && !(manual && ['session', 'dismissed'].includes(reason))) return;
    previousFocus = document.activeElement; scrollY = window.scrollY;
    step = 'pick'; card = 0; q('.sr-form').reset(); q('.sr-error').textContent = ''; render();
    viewport();
    savedBody = { position: document.body.style.position, top: document.body.style.top, width: document.body.style.width, overflow: document.body.style.overflow };
    Object.assign(document.body.style, { position: 'fixed', top: -scrollY + 'px', width: '100%', overflow: 'hidden' });
    dialog.showModal(); dialog.scrollTop = 0; dialog.focus({ preventScroll: true });
    write({ shownAt: Date.now(), lastActivity: Date.now() });
    teaser.hidden = true;
  }
  function close() {
    if (!dialog.open) return;
    clearTimeout(revealTimer);
    if (step !== 'done') write({ dismissedAt: Date.now() });
    q('#sr-email').blur(); dialog.close();
  }
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => {
    if (savedBody) Object.assign(document.body.style, savedBody);
    window.scrollTo(0, scrollY);
    q('#sr-email').value = '';
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    teaser.hidden = !['dismissed', 'session', null].includes(excluded());
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
  });
  q('.sr-close').addEventListener('click', close);
  teaser.addEventListener('click', () => open(true));
  root.querySelectorAll('[data-card]').forEach(button => button.addEventListener('click', () => {
    if (card) return;
    card = Number(button.dataset.card); render();
    revealTimer = setTimeout(() => {
      step = 'capture'; render(); dialog.scrollTop = 0;
      (innerWidth > 700 ? q('#sr-email') : dialog).focus({ preventScroll: true });
    }, matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : 400);
  }));
  q('.sr-form').addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !q('.sr-form').reportValidity()) return;
    const error = q('.sr-error'); error.textContent = ''; delete error.dataset.reason;
    if (q('[name="company_website"]').value) { error.textContent = 'Die Anmeldung konnte nicht abgeschlossen werden.'; return; }
    if (!config.companyId || !config.listId) { error.textContent = 'Die Anmeldung ist gerade nicht verfügbar. Bitte versuchen Sie es später erneut.'; return; }
    busy = true; const button = q('[type="submit"]'); button.disabled = true; button.textContent = '…';
    const controller = new AbortController(); const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(config.companyId), {
        method: 'POST', signal: controller.signal,
        headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: config.preview ? 'Serinia Popup QA 2026-09' : 'Serinia Custom Popup 2026-09',
          profile: { data: { type: 'profile', attributes: {
            email: q('#sr-email').value.trim(),
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
            properties: { serinia_signup_source: 'custom_popup_2026', serinia_popup_preview: config.preview,
              serinia_consent_version: 'exclusive-email-offers-note-2026-09-21', serinia_popup_card: card }
          } } }
        }, relationships: { list: { data: { type: 'list', id: config.listId } } } } })
      });
      if (response.status !== 202) {
        const failure = new Error('request-failed');
        failure.status = response.status;
        try {
          const body = await response.json();
          failure.emailInvalid = Array.isArray(body.errors) && body.errors.some(item =>
            /\/email$/.test(item.source?.pointer || ''));
        } catch (_) { /* Some rejected requests return an empty response. */ }
        throw failure;
      }
      // 202 means accepted for processing; it is not a confirmed profile sync.
      write({ submittedAt: Date.now() });
      if (!dialog.open) { teaser.hidden = true; return; }
      q('#sr-email').blur(); q('#sr-email').value = ''; step = 'done'; render(); dialog.scrollTop = 0;
      q('.sr-continue').focus({ preventScroll: true });
    } catch (failure) {
      const reason = failure.name === 'AbortError' ? 'timeout' : failure.status ? 'http-' + failure.status : 'connection';
      // No email address, response body or personal data in diagnostic output.
      error.dataset.reason = reason;
      console.warn('[Serinia popup] Anmeldung fehlgeschlagen:', reason);
      error.textContent = reason === 'timeout'
        ? 'Die Verbindung dauert zu lange. Bitte versuchen Sie es erneut.'
        : reason === 'connection'
          ? 'Die Verbindung zur Anmeldung konnte nicht hergestellt werden. Bitte versuchen Sie es erneut oder prüfen Sie Ihren Inhaltsblocker.'
          : failure.status === 429
            ? 'Bitte warten Sie einen Moment und versuchen Sie es erneut.'
            : failure.emailInvalid
              ? 'Bitte prüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.'
              : 'Die Anmeldung ist gerade nicht verfügbar. Bitte versuchen Sie es später erneut.';
    } finally { clearTimeout(timeout); busy = false; button.disabled = false; button.textContent = 'WEITER'; }
  });
  q('.sr-continue').addEventListener('click', () => {
    if (!config.discountCode) { close(); return; }
    const url = new URL(location.href);
    url.searchParams.delete('sr_popup');
    try { sessionStorage.setItem('serinia.popup.return', JSON.stringify({ path: url.pathname, y: scrollY, at: Date.now() })); } catch (_) {}
    location.assign('/discount/' + encodeURIComponent(config.discountCode) + '?redirect=' + encodeURIComponent(url.pathname + url.search + url.hash));
  });
  try {
    const position = JSON.parse(sessionStorage.getItem('serinia.popup.return') || 'null');
    if (position && position.path === location.pathname && Date.now() - position.at < 60000) {
      sessionStorage.removeItem('serinia.popup.return');
      window.addEventListener('load', () => window.scrollTo(0, position.y), { once: true });
    }
  } catch (_) {}
  window.visualViewport?.addEventListener('resize', viewport);
  window.addEventListener('resize', viewport);
  window.addEventListener('storage', event => {
    if (event.key === key && read().submittedAt) { teaser.hidden = true; if (dialog.open && !busy && step !== 'done') close(); }
  });
  ['pointerdown', 'keydown', 'scroll'].forEach(name => document.addEventListener(name, () => {
    if (Date.now() - lastActivityWrite > 30000) { write({ lastActivity: Date.now() }); lastActivityWrite = Date.now(); }
  }, { passive: true }));
  const timer = setInterval(() => {
    const now = performance.now(), delta = Math.min(now - lastTick, 1500); lastTick = now;
    if (document.hidden || competingUI()) return;
    elapsed += delta;
    if (elapsed < config.delayMs) return;
    clearInterval(timer);
    open();
    if (!dialog.open && ['dismissed', 'session'].includes(excluded())) teaser.hidden = false;
  }, 500);
})();
